import { useEffect, useRef, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LangContext, ScrollContext } from "@/context";
import { translations } from "@/i18n";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Footer from "@/components/Footer";
import ServicePage from "@/components/ServicePage";
import ExperiencePage from "@/components/ExperiencePage";
import AboutPage from "@/components/AboutPage";
import FeesPage from "@/components/FeesPage";
import ContactPage from "@/components/ContactPage";
import PrivacyPage from "@/components/PrivacyPage";
import Crm from "@/components/Crm";

function Landing() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Services />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  const [lang, setLang] = useState("en");
  const [service, setService] = useState("");
  const lenisRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    if (lenisRef.current) lenisRef.current.scrollTo(target, { offset: -70, duration: 1.4 });
  };

  useEffect(() => {
    if (location.hash) {
      const id = setTimeout(() => scrollTo(location.hash), 400);
      return () => clearTimeout(id);
    }
    window.scrollTo(0, 0);
    lenisRef.current?.scrollTo(0, { immediate: true });
  }, [location]);

  const t = translations[lang];

  return (
    <LangContext.Provider value={{ lang, setLang, t, service, setService }}>
      <ScrollContext.Provider value={scrollTo}>
        <div className="min-h-screen bg-ivory text-charcoal">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/experience" element={<ExperiencePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/fees" element={<FeesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/crm" element={<Crm />} />
          </Routes>
        </div>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1C1C1B",
              color: "#F7F4EE",
              border: "1px solid rgba(183,164,122,0.4)",
              borderRadius: 0,
            },
          }}
        />
      </ScrollContext.Provider>
    </LangContext.Provider>
  );
}
